import React, { useMemo, useState } from "react";

import { Popover, PopoverContent, PopoverTrigger } from "../../components/shadcn/popover";
import { cn } from "../../lib/utils";
import PromptPickerList from "./PromptPickerList";
import type { PromptPickerPopoverProps } from "../types/chat.types";

const PromptPickerPopover: React.FC<PromptPickerPopoverProps> = ({
  prompts,
  recordType,
  onSelect,
  trigger,
  hasCallRecordingWithTranscript,
}) => {
  const [open, setOpen] = useState(false);

  const elevatedTrigger = useMemo(() => {
    if (!open || !React.isValidElement(trigger)) return trigger;
    return React.cloneElement(trigger as React.ReactElement<{ className?: string }>, {
      className: cn(
        (trigger as React.ReactElement<{ className?: string }>).props.className,
        "relative z-[201]"
      ),
    });
  }, [open, trigger]);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>{elevatedTrigger}</PopoverTrigger>
      <PopoverContent
        align="start"
        side="top"
        sideOffset={8}
        collisionPadding={12}
        className="z-[200] w-80 p-0"
        style={{ zIndex: 200 }}
      >
        <PromptPickerList
          listId="prompt-picker-popover-list"
          prompts={prompts}
          recordType={recordType}
          showSearch
          onSelect={(p) => {
            onSelect(p);
            setOpen(false);
          }}
          hasCallRecordingWithTranscript={hasCallRecordingWithTranscript}
        />
      </PopoverContent>
    </Popover>
  );
};

export default PromptPickerPopover;
